import List, { type ListProps } from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { classes, styles } from './utils';

export interface AccountsListProps extends Omit<ListProps, 'onSelect'> {
  accounts?: { id: number; name: string }[];
  onSelect: (accountId: number) => void;
}

export default function AccountsList({
  accounts = [],
  onSelect,
  ...props
}: AccountsListProps) {
  return (
    <List {...props}>
      {accounts.map(({ id, name }) => (
        <ListItem key={id} disablePadding>
          <ListItemButton
            sx={styles.listItemButton}
            className={classes.listItemButton}
            onClick={() => onSelect(id)}>
            <ListItemText primary={name} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
}
